/* eslint-disable @typescript-eslint/no-explicit-any */

import { IStorage } from './definition';
import { hashKey } from './key';

class TemporaryStorage implements IStorage {
  get<T = any>(key: string, defaultValue?: T): T | undefined {
    const saved = JSON.parse(sessionStorage.getItem(hashKey(key))!);

    if (saved?.data && Date.now() < saved.validity) return saved.data;

    this.delete(key);

    return defaultValue;
  }

  set(key: string, data: any, validity?: Date): void {
    sessionStorage.setItem(
      hashKey(key),
      JSON.stringify({
        data,
        validity: Number(validity ?? Number.MAX_SAFE_INTEGER),
      }),
    );
  }

  delete(key: string): void {
    sessionStorage.removeItem(hashKey(key));
  }

  clear(): void {
    sessionStorage.clear();
  }
}

export const temporaryStorage = new TemporaryStorage();
